module.exports = __webpack_public_path__ + "img/mjjh3.24ebdac6.jpg";